import { render, staticRenderFns } from "./ConsultationIcon.vue?vue&type=template&id=ef527a6c"
import script from "./ConsultationIcon.vue?vue&type=script&lang=js"
export * from "./ConsultationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports